import * as ActionTypes from '../components/actions/types';

const initialState = [];

function cmsEventRankingReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CMS_EVENT_RANKING:
      return action.payload;
    case ActionTypes.SET_EVENT_SUBMISSION_VISIBILITY:
      return state.map(
        ranking =>
        (ranking.submission.id === action.submissionId
          ? {
            ...ranking,
            submission: {
              ...ranking.submission,
              isPrivate: action.payload
            }
          }
          : ranking),
      );
    case ActionTypes.SET_ALL_EVENTS_SUBMISSION_VISIBILITY:
      return state.map(ranking => ({
        ...ranking,
        submission: {
          ...ranking.submission,
          isPrivate: action.payload
        }
      }));
    // case ActionTypes.GIVE_CMS_EVENT_AWARD:
    //   return state.map(ranking => {
    //     const submission = { ...ranking.submission };
    //     if (submission.id === action.submissionId) {
    //       return {
    //         ...ranking,
    //         awardWon: [
    //           ...ranking.awardWon,
    //           { id: action.payload }
    //         ]
    //       };
    //     }

    //     return ranking;
    //   });
    // case ActionTypes.CANCEL_CMS_EVENT_AWARD:
    //   return state.map(ranking => {
    //     const submission = { ...ranking.submission };
    //     if (submission.id === action.submissionId) {
    //       return {
    //         ...ranking,
    //         awardWon: filter(ranking.awardWon, awd => awd.id !== action.payload),
    //       };
    //     }

    //     return ranking;
    //   });
    case ActionTypes.RESET_RANKING_SCORES:
      return state.map(ranking => ({
        ...ranking,
        judges: ranking.judges.map(j => ({
          ...j,
          judgingScores: []
        }))
      }));
    default:
      return state;
  }
}

export default cmsEventRankingReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEventRanking.js